import {Button, ButtonGroup} from "@material-ui/core";
import React from "react";
import {BUTTON_STATE} from "../constant";

export const HHMMFromMilliseconds = (ms)=> {
    // 1- Convert to seconds:
    var seconds = ms / 1000;

    // 2- Extract hours:
    var hours = parseInt(seconds / 3600); // 3600 seconds in 1 hour
    seconds = parseInt(seconds % 3600); // extract the remaining seconds after extracting hours

    // 3- Extract minutes:
    var minutes = parseInt(seconds / 60); // 60 seconds in 1 minute

    // 4- Keep only seconds not extracted to minutes:

    // 5 - Format so it shows a leading zero if needed
    let hoursStr = ("" + hours).slice(-2);
    let minutesStr = ("" + minutes).slice(-2);

    return hoursStr?hoursStr + "h " + minutesStr + "m":minutesStr + "m"
}

export const getSessionState = (data) => {
    if(new Date(data.publishDate) < new Date()){
        if(new Date(data.startDate) <= new Date() &&  new Date() < new Date(data.endDate)){
            return BUTTON_STATE.LIVE;
        }else if(new Date() >= new Date(data.endDate)){
           return  (data.vodUrl && data.vodUrl.length>0) ? BUTTON_STATE.VOD : BUTTON_STATE.ENDED
        }else{
            return BUTTON_STATE.LIVE
        }
    }else{
        return BUTTON_STATE.UNPUBLISHED
    }
}
